import {
  IPayoutItem,
  IPayoutResponse
} from "../../../services/api/payments/payouts/types";
export function isInstantPayoutItem(item: IPayoutItem) {
  return item.sourceSubType === "InstantPayoutDrawback";
}

export function getPayoutInvoiceIds(payout: IPayoutResponse) {
  const items = [
    ...(payout.payoutItems || []),
    ...(payout.clearingItems || []),
    ...(payout.futureDebitItems || [])
  ];

  return items
    .filter(item => item.sourceType === "Invoice" && !isInstantPayoutItem(item))
    .map(i => i.sourceId);
}

export function getTotals(
  payout: IPayoutResponse,
  previousPayout?: IPayoutResponse
) {
  const previousFutureDebitItems = previousPayout?.futureDebitItems || [];
  const previousFutureDebitItemsTotal = Math.abs(
    caclulateTotal(previousFutureDebitItems)
  );

  const payoutItems = payout.payoutItems || [];
  const payoutItemsTotal = caclulateTotal(payoutItems);

  const clearingItems = payout.clearingItems || [];
  const clearingItemsTotal = caclulateTotal(clearingItems);

  const futureDebitItems = payout.futureDebitItems || [];
  const futureDebitItemsTotal = caclulateTotal(futureDebitItems);

  const netTotal = getPayoutNet(payout);

  const otherItemsTotal =
    netTotal - (previousFutureDebitItemsTotal + payoutItemsTotal);

  return {
    previousFutureDebitItems,
    previousFutureDebitItemsTotal,
    payoutItems,
    payoutItemsTotal,
    clearingItems,
    clearingItemsTotal,
    futureDebitItems,
    futureDebitItemsTotal,
    otherItemsTotal,
    netTotal
  };
}

export function getPayoutNet(payout: IPayoutResponse) {
  const amount = getPayoutDisbursedAmount(payout);

  if (amount < 0) {
    return 0;
  }

  return amount;
}

function getPayoutDisbursedAmount(payout: IPayoutResponse): number {
  if (typeof payout.labels?.totalPayoutAmount === "number") {
    return payout.labels.totalPayoutAmount;
  }

  const completeTransfers = (payout.externalFundsTransfers || []).filter(
    transfer =>
      transfer.status === "Complete" ||
      // A payout-v3 Clearing retry can hand off the final write to the
      // legacy writer, which omits `status` on the transfer entry (PLA-3327).
      // Once the payout itself is Complete, an untagged transfer is the
      // disbursement, not an in-flight one.
      (payout.status === "Complete" && !transfer.status)
  );

  if (completeTransfers.length > 0) {
    return Math.abs(caclulateTotal(completeTransfers));
  }

  // Neither signal available - preserve legacy behavior.
  return (payout.currentPeriodBalance || 0) - (payout.futureDebits || 0);
}

function caclulateTotal(items: Array<{ amount: number }>) {
  return items.reduce((acc, i) => acc + i.amount, 0);
}
